export default __webpack_public_path__ + "static/57-c319f5f22853dc121c475fb2287053e4.gif";